import { create } from 'zustand';
import { AccountApi, ApiUtils, type StoreBaseReturn, type UploadCreditFormRequest } from '@shared/api';

interface UseUploadCreditFormStore {
  loading: boolean;
  data: boolean;
  error: string | null;
  uploadCreditForm: (request: UploadCreditFormRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<boolean>>;
  clear: () => void;
}

export const useUploadCreditFormStore = create<UseUploadCreditFormStore>((set) => ({
  loading: false,
  data: false,
  error: null,

  uploadCreditForm: async (request, signal) => {
    try {
      set({ loading: true, data: false, error: null });
      await AccountApi.uploadCreditForm(request, signal);
      set({ loading: false, data: true });
      return { loading: false, data: true, error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: false, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, data: false, error: null }),
}));
